import { connect, mapReadPretty } from '@formily/react'
import { InputNumber as AtndInputNumber, Space } from 'antd'
import { isNil } from 'lodash'

import { InputNumberProps } from './interface'

const Component = ({
  /* ************************************************************************** */
  /*                             Space.Compact Props                            */
  /* ************************************************************************** */
  block,
  /* ************************************************************************** */
  /*                              InputNumber Props                             */
  /* ************************************************************************** */
  controls = false,
  keyboard = false,
  max,
  addonAfter,
  addonBefore,
  ...restProps
}: InputNumberProps) => {
  const safeMax = isNil(max)
    ? Number.MAX_SAFE_INTEGER
    : Math.min(max, Number.MAX_SAFE_INTEGER)

  const inputNumberNode = (
    <AtndInputNumber
      controls={controls}
      keyboard={keyboard}
      max={safeMax}
      {...restProps}
    />
  )

  return addonBefore || addonAfter ? (
    <Space.Compact block={block}>
      {addonBefore && (
        <Space.Addon style={{ whiteSpace: 'nowrap' }}>
          {addonBefore}
        </Space.Addon>
      )}
      {inputNumberNode}
      {addonAfter && (
        <Space.Addon style={{ whiteSpace: 'nowrap' }}>{addonAfter}</Space.Addon>
      )}
    </Space.Compact>
  ) : (
    inputNumberNode
  )
}

export const InputNumber = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
